import { useMemo } from 'react';
import { SmallLink } from './Typography';
import Link, { LinkProps } from './Link';
import { useTranslation } from '../lib/hooks';

const EditLinkStyle = SmallLink.withComponent(Link);

const EditLink = ({ children, ...props }: LinkProps) => {
  const t = useTranslation();
  const linkText = useMemo(() => children || t('links.edit'), [children, t]);
  return <EditLinkStyle {...props}>{linkText}</EditLinkStyle>;
};

export default EditLink;
